import React, { useState, useEffect, useContext } from "react";
import AddStore from "../components/AddStore";
import AuthContext from "../AuthContext";

function Store() {
  const [showModal, setShowModal] = useState(false);
  const [stores, setAllStores] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editData, setEditData] = useState({ name: "", address: "", city: "" });

  const authContext = useContext(AuthContext);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(`https://stock.krishtec.co.in/stock/get_stores.php`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setAllStores(data.data);
        } else {
          console.error("Unexpected API response format", data);
          setAllStores([]);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setAllStores([]);
      });
  };

  const modalSetting = () => {
    setShowModal(!showModal);
  };
  const handleDelete = (id) => {
    fetch(`https://stock.krishtec.co.in/stock/delete_store.php`, {
      method: "POST",  // Use POST instead of DELETE
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) fetchData();
        else console.error("Delete failed:", data.error);
      })
      .catch((err) => console.error("Delete error:", err));
  };
  
  const handlePageUpdate = () => {
    fetchData();
  };
  
  const startEditing = (index) => {
    setEditIndex(index);
    setEditData({ ...stores[index] });
  };

  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    fetch(`https://stock.krishtec.co.in/stock/edit_store.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          fetchData();
          setEditIndex(null);
        } else {
          alert("Failed to update store.");
        }
      })
      .catch((err) => console.error("Update error:", err));
  };

  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12 border-2 p-4">
        <div className="flex justify-between items-center">
          <span className="font-bold text-lg">Manage Store</span>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 text-xs rounded"
            onClick={modalSetting}
          >
            Add Store
          </button>
        </div>

        {showModal && <AddStore
  modalSetting={modalSetting}
  handlePageUpdate={handlePageUpdate}
  authContext={authContext}
/>
}

        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border border-gray-300">
            <thead className="bg-gray-200 text-gray-700">
              <tr>
                <th className="px-4 py-2 border">S.No</th>
                <th className="px-4 py-2 border">Store Name</th>
                <th className="px-4 py-2 border">Address</th>
                <th className="px-4 py-2 border">City</th>
                <th className="px-4 py-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {stores.map((element, index) => (
                <tr key={element.id} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2 border">{index + 1}</td>
                  {editIndex === index ? (
                    <>
                      <td className="px-4 py-2 border">
                        <input
                          type="text"
                          name="name"
                          value={editData.name}
                          onChange={handleEditChange}
                          className="border px-2 py-1 rounded w-full"
                        />
                      </td>
                      <td className="px-4 py-2 border">
                        <input
                          type="text"
                          name="address"
                          value={editData.address}
                          onChange={handleEditChange}
                          className="border px-2 py-1 rounded w-full"
                        />
                      </td>
                      <td className="px-4 py-2 border">
                        <input
                          type="text"
                          name="city"
                          value={editData.city}
                          onChange={handleEditChange}
                          className="border px-2 py-1 rounded w-full"
                        />
                      </td>
                      <td className="px-4 py-2 border flex gap-2">
                        <button
                          className="bg-green-500 text-white px-3 py-1 rounded"
                          onClick={handleSave}
                        >
                          Save
                        </button>
                        <button
                          className="bg-gray-400 text-white px-3 py-1 rounded"
                          onClick={() => setEditIndex(null)}
                        >
                          Cancel
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="px-4 py-2 border">{element.name}</td>
                      <td className="px-4 py-2 border">{element.address}</td>
                      <td className="px-4 py-2 border">{element.city}</td>
                      <td className="px-4 py-2 border flex gap-2">
                        <button
                          className="bg-yellow-500 text-white px-3 py-1 rounded"
                          onClick={() => startEditing(index)}
                        >
                          Edit
                        </button>
                        <button
                          className="bg-red-500 text-white px-3 py-1 rounded"
                          onClick={() => handleDelete(element.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Store;
